import type { TSalvarSimulacaoBody, TSimulacaoVerticalOutput } from '@/features/simulador/brasil/types/simulacao.type'
import { HttpService } from '@/infra/http'
import type { TGetSimulacaoProdutoResponse } from '@/types/simulacao'

export type TRotinaArquivo = {
  rotina: string
  arquivo: string
  valorPresente: number
  comissaoVendedor: number
  valorMedioTotal: number
  valorMedioTotalUPF: number
  margemBruta: number
  margemLiquida: number
  fatorVendedor1Por3: number | null
  fatorVendedor2Por3: number | null
  fatorVendedor3Por3: number | null
  fatorGcom: number
  fatorGR: number
  valorPresentePontoMedio: number
  valorPresentePontoMedioUPF: number
  percentualMargemVenda: number
}

export type TCreateSimulacaoResponse = {
  id: string
  message: string
  date: string
  data: TSimulacaoVerticalOutput['simulacao'] & { vendedorId: string; clienteId: string }
}

export class CreateSimulacaoService extends HttpService {
  execute = async (simulacao: TSalvarSimulacaoBody) => {
    return this.http.post<{ data: TGetSimulacaoProdutoResponse }>('api/v2/Simulacao', simulacao)
  }
}
